import API from './../../../api';

export default {
	data() {
		return {
			reportsLoaded: false,
			resource: null,
			reportType: null,
			formData: {},
			resultCount: null,
		}
	},
	methods: {
		getResourceCount() {
			this.fetchResourceCount().then(count => {
				this.resultCount = count;
			});
		},
		fetchResourceCount() {
			return Promise.reject('Not implemented');
		},
		createReport() {
			API.createReport({
				resource: this.resource,
				type: this.reportType,
				...this.formData,
			}).then(() => this.$refs.reports.load(true));
		},
		load() {
			this.$refs.reports.load(true);
			this.loaded = true;
		}
	},
	watch: {
		formData: {
			deep: true,
			handler() {
				this.getResourceCount();
			}
		}
	},
}
